import React  from 'react'
import AnimatedLogo from '../animated-logo/AnimatedLogo'
import useShopType from '../../customHook/useShopType'
import LogoIcon from '../../assets/images/logo-icon-black.svg'


function DefaultHeader({heading,subheading,headerTop, animationColor, logoSize, hideSubHeading=true}){
     const {isIdntfy} = useShopType()
  return (
    headerTop ?<>
    <div className={`flex items-center w-full ${headerTop === "logoOnly" ? "justify-center" : "justify-between"} ${headerTop === "logoOnlyLeft" ? "justify-start" : ""}`}>
      {headerTop !=="logoOnly" && headerTop !=="logoOnlyLeft" && <span className='font-headingFonts text-[24px] italic'>Swan</span>}  
        <img src={LogoIcon} alt='logo' className='w-[30px] h-[30px]'  />
            </div> 
             <h1>{heading||`Welcome to ${ isIdntfy ? 'Idntfy'   : 'Swan' }`}</h1>
      {hideSubHeading &&  <p>{subheading||"Let's get to know you better"}</p>}
            </> :
    <div>
    
        <span className={logoSize}>
     {!isIdntfy &&<AnimatedLogo animationColor={animationColor}/> }
        </span>
        <h1>{heading||`Welcome to ${ isIdntfy ? 'Idntfy'   : 'Swan' }`}</h1>
      {hideSubHeading &&  <p>{subheading||"Let's get to know you better"}</p>}
       
    </div>
  )
}

export default DefaultHeader